import React from "react";
import NurseAddContents from "./NurseAddContents";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";

interface NurseAddModalProps {
  onClose: () => void;
  selectedGroupId?: string | null;
}

const NurseAddModal: React.FC<NurseAddModalProps> = ({
  onClose,
  selectedGroupId,
}) => {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        overlayClassName="bg-black/45"
        className="h-[min(800px,calc(100vh-40px))] w-[min(1120px,calc(100vw-96px))] max-w-none gap-0 overflow-hidden rounded-[10px] border-0 bg-white p-0 font-pretendard shadow-lg"
      >
        <DialogTitle className="sr-only">근무자 추가</DialogTitle>
        <NurseAddContents
          onClose={onClose}
          selectedGroupId={selectedGroupId!}
        />
      </DialogContent>
    </Dialog>
  );
};

export default NurseAddModal;
